// extracted by mini-css-extract-plugin
export default {"outerframe":"AdViseStep8_outerframe__tWBKQ","previewOverlay":"AdViseStep8_previewOverlay__428Ay"};